import React from 'react';
import JSONPretty from 'react-json-pretty';

const CourtsContent = ({ courts =[] }) => {
    return (
        <JSONPretty data={courts} />
    );
};

export default CourtsContent;